import type {Mutator} from 'final-form'
import arrayMutators from 'final-form-arrays'
import type {Schedule, ScheduledBreak} from '../types/domain'

const isAffectedAttachment = (level: number, count: number, index: number) => Number.isInteger(level) && level <= count && level > index

const insertBlind: Mutator<Schedule> = ([index, blind], state, tools) => {
  const count = state.formState.values.blinds.length
  tools.changeValue(state, 'breaks', (breaks: ScheduledBreak[]) => breaks.map(segment => ({
    ...segment,
    afterLevelNumber: isAffectedAttachment(segment.afterLevelNumber, count, index) ? segment.afterLevelNumber + 1 : segment.afterLevelNumber,
  })))
  arrayMutators.insert(['blinds', index, blind], state, tools)
}

const removeBlind: Mutator<Schedule> = ([index], state, tools) => {
  const count = state.formState.values.blinds.length
  tools.changeValue(state, 'breaks', (breaks: ScheduledBreak[]) => breaks.map(segment => {
    const level = segment.afterLevelNumber
    if (!isAffectedAttachment(level, count, index)) return segment
    return {...segment, afterLevelNumber: level === index + 1 ? 0 : level - 1}
  }))
  arrayMutators.remove(['blinds', index], state, tools)
}

export const blindLevelMutators = {insertBlind, removeBlind}
